import {
	DETAIL_TRACK,
	DETAIL_TRACK_,
	PRIMARY_TRACK,
	PRIMARY_TRACK_,
	SECONDARY_TRACK,
	SECONDARY_TRACK_,
} from "components/Transactional/Performance/components/Timeline/utils"

export const mapDates: Record<string, string> = {
	[PRIMARY_TRACK]: "primaryDate",
	[PRIMARY_TRACK_]: "primaryDate",
	[SECONDARY_TRACK]: "secondaryDate",
	[SECONDARY_TRACK_]: "secondaryDate",
}

export const mapGrowth: Record<string, string> = {
	[PRIMARY_TRACK]: DETAIL_TRACK,
	[SECONDARY_TRACK]: DETAIL_TRACK,
	[PRIMARY_TRACK_]: DETAIL_TRACK_,
	[SECONDARY_TRACK_]: DETAIL_TRACK_,
}

export const GROWTH = "growth"
